const Container = {
  baseStyle: { w: "100%", mx: "auto", maxW: "100%", px: "0", py: "0" },
}

export default Container
